/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Notepad/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Notepad({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Notepad",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Notepad.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-2h5Pau': alignSelf,'--mt-2-2h5Pau': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2h5Pau': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2h5Pau': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2h5Pau': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2h5Pau': opacity,'--w-10-2h5Pau': typeof width === 'number' ? `${width}px` : width,'--h-11-2h5Pau': typeof height === 'number' ? `${height}px` : height,'--f-12-2h5Pau': fill,'--a-7-2h5Pau': isAnimated ? animation : "none",'--sd-8-2h5Pau': isAnimated ? strokeDashoffset : 0,'--sd-9-2h5Pau': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Notepad.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.857.857a.857.857 0 00-1.714 0v.857h-.857C.576 1.714 0 2.29 0 3v7.714C0 11.424.576 12 1.286 12h9.428c.71 0 1.286-.576 1.286-1.286V3c0-.71-.576-1.286-1.286-1.286h-.857V.857a.857.857 0 10-1.714 0v.857H6.857V.857a.857.857 0 00-1.714 0v.857H3.857V.857zM3.195 4.07a.536.536 0 01.43.623c-.045.255-.114.578-.187.922l-.041.193c-.089.42-.181.867-.253 1.283-.055.315-.095.6-.115.837.25-.268.541-.642.844-1.049a76.2 76.2 0 00.342-.465c.212-.29.418-.573.596-.8.137-.175.274-.34.398-.463.061-.06.137-.127.223-.181a.667.667 0 01.484-.1c.396.079.495.45.518.548.035.15.04.32.036.468a12.39 12.39 0 01-.097 1.067l-.003.023a23.19 23.19 0 00-.087.818c.112-.135.234-.286.363-.449l.142-.18c.232-.294.477-.604.695-.85a3.81 3.81 0 01.403-.403c.067-.055.145-.113.232-.158A.7.7 0 019.08 6c.087.139.13.297.156.415.036.166.063.384.088.587l.03.23c.038.285.086.534.165.729.077.192.158.267.224.297a.536.536 0 01-.446.974c-.412-.189-.64-.543-.772-.87-.131-.326-.193-.687-.234-.985l-.04-.311v-.003c-.187.215-.395.48-.615.757l-.15.191c-.276.348-.573.715-.829.959a1.518 1.518 0 01-.467.325.71.71 0 01-.435.033.658.658 0 01-.41-.317 1.286 1.286 0 01-.143-.518 3.825 3.825 0 01-.005-.522c.017-.343.064-.74.107-1.102l.005-.042.013-.112-.226.309-.363.494c-.334.45-.696.917-1.024 1.248-.16.162-.342.323-.533.425-.175.095-.522.222-.855-.001-.232-.156-.308-.406-.338-.547a2.265 2.265 0 01-.038-.519c.009-.351.068-.782.143-1.215.076-.438.172-.901.26-1.322l.043-.2c.073-.344.137-.648.18-.886a.536.536 0 01.624-.431zM5.39 5.66v.002a.101.101 0 010-.003zM3.033 8.43c.003.006.003.01.003.01l-.003-.01z"
 style={{'--f-12-2h5Pau': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}